export default {
  refreshYourResults: 'Refresh your results',
  weNeedTo: 'For the latest prices and availability, we need to',
  refreshResults: 'refresh your results.',
  okRefresh: 'Ok, refresh',
}
